import { EventCategory, HeapLoadAnalyticsEvent } from "healthex-common/analytics.dtos";
export async function loadHeap(timeoutMs = 3000) {
    try {
        const appId = window.ENVIRONMENT.HEAP_APP_ID;
        window.heap = window.heap || [];
        window.heap.appid = appId;
        window.heap.config = { disableTextCapture: true, secureCookie: true };
        setupHeapStubs();
        const heapLoadResult = await loadScriptWithTimeout(`https://cdn.heapanalytics.com/js/heap-${appId}.js`, timeoutMs);
        if (heapLoadResult.status === "failed") {
            console.error("Heap did not load", heapLoadResult.failureCode, heapLoadResult.failureMessage);
        }
        return heapLoadResult;
    }
    catch (error) {
        const failureMessage = error instanceof Error ? error.message : String(error);
        console.error("Unexpected error while loading heap", error);
        return { status: "failed", failureCode: "UNEXPECTED_ERROR", failureMessage };
    }
}
function loadScriptWithTimeout(scriptUrl, timeoutMs) {
    return new Promise((resolve) => {
        const scriptElement = document.createElement("script");
        let hasSettled = false;
        const detachScriptHandlers = () => {
            scriptElement.onload = null;
            scriptElement.onerror = null;
        };
        const settleOnce = (outcome) => {
            if (hasSettled) {
                return;
            }
            hasSettled = true;
            clearTimeout(timeoutTimer);
            detachScriptHandlers();
            resolve(outcome);
        };
        const timeoutTimer = setTimeout(() => {
            detachScriptHandlers();
            scriptElement.src = "";
            scriptElement.remove();
            settleOnce({
                status: "failed",
                failureCode: "TIMEOUT",
                failureMessage: `Timed out after ${timeoutMs}ms loading script`,
            });
        }, timeoutMs);
        scriptElement.async = true;
        scriptElement.onload = () => settleOnce({ status: "success" });
        scriptElement.onerror = () => settleOnce({ status: "failed", failureCode: "SCRIPT_LOAD_FAILED", failureMessage: "Failed to load script" });
        scriptElement.src = scriptUrl;
        document.head.appendChild(scriptElement);
    });
}
function setupHeapStubs() {
    const methods = [
        "addEventProperties",
        "addUserProperties",
        "clearEventProperties",
        "identify",
        "resetIdentity",
        "removeEventProperty",
        "setEventProperties",
        "track",
        "unsetEventProperty",
    ];
    for (const method of methods) {
        heap[method] = (...args) => heap.push([method, ...args]);
    }
    heap.getSessionId = () => undefined;
}
export function trackHeapLoadResult(analyticsService, heapLoadResult, actorId) {
    try {
        const heapLoadMetadata = heapLoadResult.status === "failed"
            ? { status: heapLoadResult.status, failureCode: heapLoadResult.failureCode, failureMessage: heapLoadResult.failureMessage }
            : { status: heapLoadResult.status };
        void analyticsService.trackPublicEvent({
            category: EventCategory.PATIENT,
            action: HeapLoadAnalyticsEvent.HEAP_SCRIPT_LOAD_RESULT,
            actorId,
            metadata: heapLoadMetadata,
        });
    }
    catch (error) {
        console.error("Failed to track heap load result", error);
    }
}
export function updateHeapGlobalEventProperties(updatedProperties) {
    const existingProperties = getHeapGlobalEventProperties();
    sessionStorage.setItem("heapGlobalEventProperties", JSON.stringify({
        ...existingProperties,
        ...updatedProperties,
    }));
}
export function getHeapGlobalEventProperties() {
    const existingProperties = sessionStorage.getItem("heapGlobalEventProperties");
    return existingProperties ? JSON.parse(existingProperties) : {};
}
